module.exports = "<list-workwaves-schedule></list-workwaves-schedule>\n"